export enum AssignationStatusFilters {
  ALL = "All",
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}
